module.exports = __webpack_public_path__ + "static/liscie-dbe9491cda995c8d05c2041d57928f25.jpg";